export const SIDE_NAV_WIDTH = '32rem'

// Note: sticky navbar (56px) + page gap; sticky headers inside the content use the same offset so
// they line up with the nav's top border
export const SIDE_NAV_STICKY_TOP = 76
